module.exports = __webpack_public_path__ + "static/img/img_chanpin_zhongxin_banner_small.13a1875a.png";